import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaMapMarkerAlt, FaCalendarAlt, FaLinkedin } from 'react-icons/fa';
import { getBrand } from '../utils/brandStyles';
import PageHero from '../components/PageHero';

const Contact = ({ market, content }) => {
  const b = getBrand(market);
  const [showForm, setShowForm] = useState(false);

  const methods = [
    {
      icon: <FaEnvelope size={28} color={b.accent} />,
      title: 'Email Us',
      value: content.email,
      link: `mailto:${content.email}`
    },
    {
      icon: <FaMapMarkerAlt size={28} color={b.accent} />,
      title: 'Location',
      value: content.location,
      link: null
    },
    {
      icon: <FaLinkedin size={28} color={b.accent} />,
      title: 'LinkedIn',
      value: 'Connect with us',
      link: content.linkedin
    }
  ];

  return (
    <div style={{ fontFamily: b.fontBody, color: b.text, background: b.bg }}>

      {/* ── HERO ── */}
      <PageHero
        market={market}
        title="Get In Touch"
        subtitle={
          market === 'lu'
            ? "Ready to modernise your IT? Let's discuss how we can help your Luxembourg business thrive."
            : "Let's explore how we can transform your business with expert IT solutions and strategic advisory."
        }
      />

      {/* ── CONTACT METHODS — 3 cards ── */}
      <section style={{ background: b.bgAlt, padding: b.secPad }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>

          {market === 'lu' && (
            <div style={{
              display: 'inline-block',
              background: 'rgba(0,188,212,0.1)',
              color: '#0097A7',
              fontWeight: 700,
              fontSize: '13px',
              padding: '6px 18px',
              borderRadius: '100px',
              marginBottom: '40px'
            }}>
              Now accepting clients for March 2026 launch
            </div>
          )}

          {/* 3 cards: fixed 3-column grid */}
          <div className="grid-3" style={{ marginBottom: '48px' }}>
            {methods.map((m, i) => (
              <div
                key={i}
                className={b.isMWO ? 'feature-card mwo-card' : 'feature-card mindit-card'}
                style={{
                  background: b.bgCard,
                  borderRadius: b.cardRadius,
                  boxShadow: b.cardShadow,
                  padding: '32px 24px',
                  textAlign: 'center'
                }}
              >
                <div style={{ marginBottom: '16px' }}>{m.icon}</div>
                <h3 style={{ fontFamily: b.fontDisplay, fontSize: b.fz.lg, color: b.textHeading, marginBottom: '10px' }}>
                  {m.title}
                </h3>
                {m.link ? (
                  <a
                    href={m.link}
                    target={m.link.startsWith('http') ? '_blank' : undefined}
                    rel={m.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                    style={{ color: b.accent, textDecoration: 'none', fontSize: b.fz.sm, wordBreak: 'break-all' }}
                  >
                    {m.value}
                  </a>
                ) : (
                  <p style={{ fontSize: b.fz.sm, color: b.textMuted }}>{m.value}</p>
                )}
              </div>
            ))}
          </div>

          {/* Calendar booking (bg market) */}
          {market === 'bg' && (
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <a
                href={content.ctaUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={b.ctaBtnClass}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}
              >
                <FaCalendarAlt size={14} />
                Schedule a Meeting
              </a>
            </div>
          )}

          {/* Contact form toggle */}
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            <button
              onClick={() => setShowForm(p => !p)}
              className={b.ctaBtnClass}
            >
              {showForm ? 'Hide Contact Form' : 'Send Us a Message'}
            </button>
          </div>

          {/* Contact form (iframe) */}
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: showForm ? 1 : 0, height: showForm ? 'auto' : 0 }}
            transition={{ duration: 0.45 }}
            style={{ overflow: 'hidden' }}
          >
            <iframe
              title={`${content.companyName} Contact Form`}
              src="https://forms.office.com/Pages/ResponsePage.aspx?id=EguHYHpeY0GEbtxT6iJiZen1UrG620BNq_YaMD_T6ahURFpWT1VXNE5WVDdSOEk1R1c2UldTQUtRRS4u&embed=true"
              width="100%"
              height="600"
              frameBorder="0"
              style={{ border: 'none', maxWidth: '100%', marginTop: '24px' }}
              allowFullScreen
            />
          </motion.div>
        </div>
      </section>

      {/* ── LU bottom CTA ── */}
      {market === 'lu' && (
        <section style={{ background: b.bgCTA, padding: b.secPad, textAlign: 'center' }}>
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <h2 style={{ fontFamily: b.fontDisplay, fontSize: b.h2size, color: '#fff', marginBottom: '16px', letterSpacing: '-0.02em' }}>
              Ready to Get Started?
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: b.fz.base, lineHeight: 1.75, marginBottom: '32px' }}>
              Book your free IT assessment and discover how we can help your business grow.
            </p>
            <a href="/services/assessment" className="btn-primary-mindit">Book Free Assessment</a>
          </div>
        </section>
      )}
    </div>
  );
};

export default Contact;
